export function getGridCols(w) {
  if (w >= 1800) return 7;
  if (w >= 1400) return 6;
  if (w >= 1100) return 5;
  if (w >= 800)  return 4;
  if (w >= 550)  return 3;
  return 2;
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)    return 'ahora';
  if (diff < 3600)  return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
}

export function formatMsgTime(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
}

export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
}

export function getAvatarColor(name) {
  const colors = [
    { bg: 'rgba(201,113,74,0.25)', text: '#e8956d' },
    { bg: 'rgba(52,152,219,0.2)',  text: '#5dade2' },
    { bg: 'rgba(46,204,113,0.2)',  text: '#58d68d' },
    { bg: 'rgba(155,89,182,0.2)',  text: '#a569bd' },
    { bg: 'rgba(231,76,60,0.2)',   text: '#ec7063' },
  ];
  const idx = (name || '').charCodeAt(0) % colors.length;
  return colors[idx];
}

export function formatTime(secs) {
  if (!secs) return '';
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = Math.floor(secs % 60);
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;
}

export function formatDur(secs) {
  if (!secs) return '';
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function formatSize(bytes) {
  const gb = bytes / 1024 / 1024 / 1024;
  return gb >= 1 ? `${gb.toFixed(1)} GB` : `${(bytes / 1024 / 1024).toFixed(0)} MB`;
}

// Formato de reproducción de un episodio (mismo que usa SeriesModal).
export function episodeToMedia(ep) {
  const title = ep.title || `Episodio ${ep.episode}`;
  return { id:ep.file, name:`T${ep.season}E${String(ep.episode).padStart(2,'0')} · ${title}`, file:ep.file, type:'series', thumbnail:'', series_id:ep.series_id, season:ep.season, episode:ep.episode };
}

// Episodios de la biblioteca agrupados por serie y ordenados por temporada/episodio.
export function groupEpisodes(library) {
  const bySeries = {};
  library.forEach(m => {
    if (!(m.series_id > 0) || !(m.season > 0)) return;
    (bySeries[m.series_id] = bySeries[m.series_id] || []).push(m);
  });
  Object.values(bySeries).forEach(list => list.sort((a, b) => a.season - b.season || a.episode - b.episode));
  return bySeries;
}

export function isFinished(h) {
  return !!h && h.duration > 0 && h.progress / h.duration >= 0.95;
}

export function isInProgress(h) {
  return !!h && h.progress > 10 && h.duration > 0 && h.progress / h.duration < 0.95;
}
